import { indexItems } from './mockData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 mb-4">
              <i className="ri-grid-line text-secondary-600 text-sm"></i>
              <span className="text-secondary-700 text-xs font-medium">内容索引</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              影视索引
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              按类型快速浏览，找到你想看的4K超清影视内容
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {indexItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-100 rounded-2xl p-5 md:p-6 cursor-pointer hover:bg-primary-50 transition-colors text-center"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 group-hover:bg-primary-200 transition-colors mb-4">
                  <i className={`${item.icon} text-primary-600 text-xl md:text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                  {item.desc}
                </p>
                <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full">
                  {item.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}